export default {
    blocks: [{
      key: '19lo6', text: '', type: 'header-two', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {},
    }],
    entityMap: {},
  };